import { render, staticRenderFns } from "./rolesFormUpdate.vue?vue&type=template&id=2a44e390&scoped=true&"
import script from "./rolesFormUpdate.vue?vue&type=script&lang=js&"
export * from "./rolesFormUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a44e390",
  null
  
)

export default component.exports